// sessionStorage操作
export function setStore(name, content) {
  if (!name) {
    return;
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.sessionStorage.setItem(name, content);
}
export function getStore(name) {
  let rtn = '';

  if (name) {
    rtn = JSON.parse(window.sessionStorage.getItem(name));
  }
  return rtn;
}
export function removeStore(name) {
  if (!name) {
    return;
  }
  window.sessionStorage.removeItem(name);
}

export function rem(size = 750) {
  let docEl = document.documentElement;
  let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  let reCalc = () => {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    if (clientWidth >= size) {
      docEl.style.fontSize = '100px';
    } else {
      docEl.style.fontSize = 100 * (clientWidth / size) + 'px';
    }
  };

  if (!document.addEventListener) return;
  reCalc();
  window.addEventListener(resizeEvt, reCalc, false);
  document.addEventListener('DOMContentLoaded', reCalc, false);
}

export function isWeiXin() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

export function isAndroid() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
}

export function isMobile() {
  // if (/Wechat/.test(navigator.userAgent)) {
  //     return false;
  // }
  if (
    /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
        /Android|iPhone|Windows Phone|webOS|iPod|BlackBerry/i.test(navigator.userAgent)
  ) {
    return true;
  }
  return false;
}

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getDeviceRatio() {
  var isIPhone = window.navigator.appVersion.match(/iphone/gi);
  var devicePixelRatio = window.devicePixelRatio;
  var dpr;
  if (isIPhone) {
    // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
    if (devicePixelRatio >= 3) {
      dpr = 3;
    } else if (devicePixelRatio >= 2) {
      dpr = 2;
    } else {
      dpr = 1;
    }
  } else {
    // 其他设备下，仍旧使用1倍的方案
    dpr = 1;
  }
  return dpr
}

export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');

  if (window.location.href.indexOf('?') !== -1) {
    var r = window.location.search.substr(1).match(reg);
  }
  if (window.location.href.indexOf('#') !== -1) {
    var r = window.location.href.split('#')[1].match(reg);
  }

  if (r != null) return unescape(r[2]);
  return false;
}

// $$("#xxx")
export function $$(name) {
  return document.querySelector.bind(document)(name);
}
var mztapi = mztapi || {};

mztapi.device = {
  Android: function() {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return !!navigator.userAgent.match(/iPad|iPod|iPhone/i);
  },
  iphone: function() {
    return !!navigator.userAgent.match(/iPhone/i);
  },
  Windows: function() {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (mztapi.device.Android() || mztapi.device.BlackBerry() || mztapi.device.Windows() || mztapi.device.iOS());
  }
};

mztapi.domFragment = function() {
  return document.createDocumentFragment();
}

// css3 动画回调
function whichTransitionEvent() {
  let t; let el = document.createElement('fakeelement');
  let transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  };
  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}
mztapi.css3 = function(d, call) {
  var es = $$(d);

  var transitionEvent = whichTransitionEvent();

  transitionEvent && es.addEventListener(transitionEvent, call, false);
}
mztapi.css3Stop = function(d, call) {
  var es = $$(d);
  var transitionEvent = whichTransitionEvent();
  es.removeEventListener(transitionEvent, call, false);
}

// css3 animate动画回调
mztapi.cssAnimate = function(d, call) {
  document.querySelector(d).addEventListener('animationend', () => {
    if (call)call();
  }, false);
  document.querySelector(d).addEventListener('webkitAnimationEnd', () => {
    if (call)call();
  }, false);
}

// 延时动态加载JS
mztapi.delay_script = function(A) {
  var B = document.createElement('script'); var C = 'src'; var D = 'text/javascript';
  B.setAttribute(C, A);
  B.setAttribute('type', D);
  document.body.appendChild(B);
  return B;
}

mztapi.isFunction = function(Progress) {
  return Progress instanceof Function
}

mztapi.isArray = function(arr) {
  return arr instanceof Array;
}

mztapi.isString = function(arr) {
  return arr instanceof String;
}

mztapi.isObject = function(arr) {
  return arr instanceof Object;
}

mztapi.hasClassName = function(d, a) {
  return new RegExp('(?:^|\\s+)' + a + '(?:\\s+|$)').test(d.className);
};

mztapi.addClassName = function(d, a) {
  if (!mztapi.hasClassName(d, a)) {
    d.className = [d.className, a].join(' ');
  }
};

mztapi.removeClassName = function(obj, cls) {
  if (mztapi.hasClassName(obj, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    obj.className = obj.className.replace(reg, ' ');
  }
}

mztapi.toggleClassName = function(d, a) {
	  d[d.hasClassName(a) ? 'removeClassName' : 'addClassName'](a);
};

// 新建图片方法
var sources = [];
mztapi.creatImg = function(src) {
  if (typeof sources[src] !== 'undefined') {
    return sources[src];
  }

  sources[src] = new Image();
  sources[src].src = src;
  return sources[src];
}

mztapi.ajax = function(options) {
  options = options || {};
  options.type = (options.type || 'GET').toUpperCase();
  options.dataType = options.dataType || 'json';
  var params = mztapi.formatParams(options.data);
  // 创建 - 非IE6 - 第一步
  if (window.XMLHttpRequest) { var xhr = new XMLHttpRequest(); } else {
    // IE6及其以下版本浏览器
    let xhr = new ActiveXObject('Microsoft.XMLHTTP');
  }
  // 接收 - 第三步
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      let status = xhr.status;
      if (status >= 200 && status < 300) {
        options.success && options.success(xhr.responseText, xhr.responseXML);
      } else {
        options.fail && options.fail(status);
      }
    }
  }
  // 连接 和 发送 - 第二步
  if (options.type == 'GET') {
    xhr.open('GET', options.url + '?' + params, true);
    xhr.send(null);
  } else if (options.type == 'POST') {
    xhr.open('POST', options.url, true);
    // 设置表单提交时的内容类型
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
  }
}
// 格式化参数
mztapi.formatParams = function(data) {
  var arr = [];
  for (var name in data) {
    arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
  }
  arr.push(('v=' + Math.random()).replace('.', '')); return arr.join('&');
}

// 图片预加载
mztapi.LoadImg = function() {
  this.imageUrl = '';
  // 图片资源, 存放图片对象
  this.sources = [];

  // 图片预加载方法
  this.loadImages = function(images, id, callback) {
    var loadedImages = 0;
    var numImages = images.length;

    if (id !== '') { var bfs = (100 / numImages).toFixed(2); }

    for (var i in images) {
      this.sources[images[i]] = new Image();
      this.sources[images[i]].onload = function() {
        loadedImages++;

        if (id !== '') {
          var bf = Math.round(loadedImages * bfs);
          document.getElementById(id).textContent = bf + '%';
        }
        if (loadedImages >= numImages) { setTimeout(function() { callback();	 }, 400); }
      };
      this.sources[images[i]].src = this.imageUrl + images[i];
    }
  }
}

// 动态加载JS
mztapi.loadScript = function(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        if (callback) {
          callback()
        }
      }
    }
  } else {
    script.onload = function() {
      if (callback) {
        callback()
      }
    }
  }
  script.src = url;
  document.body.appendChild(script);
}

// JS方法类相互继承
mztapi.extend = function(target, source) {
  for (var k in source) {
    target[k] = source[k];
  }
  return target;
}

export default mztapi;
